import React from 'react'
import { FaArrowLeft } from "react-icons/fa6";
import { useNavigate } from 'react-router-dom';
import barStyle from './CoordinatorPageBar.module.css'

export default function CoordinatorPageBar() {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/coordinator-dashboard');
  };

  return (
    <>
      {/*<div className={`${barStyle.barWrapper} d-flex flex-wrap align-items-center`}>
        <h5 className={`${barStyle.barTitle} d-flex me-auto m-0`}>
          <a href="#" onClick={(e) => {e.preventDefault();navigate(-1);}}>
            <span className={barStyle.iconstyle}><FaArrowLeft className='me-2'/></span>Back
          </a>
        </h5>                    
      </div>*/}
    </>
  )
}